var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdclogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.5,
    viewBox: "0 0 37.5 37.5",
    height: 37.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 16 L 18 16 L 18 27 L 0 27 Z M 0 16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.519531 12.511719 L 18.703125 24.832031 L 4.742188 29.574219 L 0.558594 17.253906 Z M 14.519531 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.519531 12.511719 L 18.703125 24.832031 L 4.742188 29.574219 L 0.558594 17.253906 Z M 14.519531 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.523438 12.523438 L 18.699219 24.820312 L 4.722656 29.566406 L 0.546875 17.269531 Z M 14.523438 12.523438"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.523438 12.523438 L 18.699219 24.820312 L 4.738281 29.558594 L 0.5625 17.265625 Z M 14.523438 12.523438"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 17 L 18 17 L 18 26 L 1 26 Z M 1 17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.519531 12.511719 L 18.703125 24.832031 L 4.742188 29.574219 L 0.558594 17.253906 Z M 14.519531 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.519531 12.511719 L 18.703125 24.832031 L 4.742188 29.574219 L 0.558594 17.253906 Z M 14.519531 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 17 L 6 17 L 6 21 L 1 21 Z M 1 17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.519531 12.511719 L 18.703125 24.832031 L 4.742188 29.574219 L 0.558594 17.253906 Z M 14.519531 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.519531 12.511719 L 18.703125 24.832031 L 4.742188 29.574219 L 0.558594 17.253906 Z M 14.519531 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4 18 L 15 18 L 15 21 L 4 21 Z M 4 18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.519531 12.511719 L 18.703125 24.832031 L 4.742188 29.574219 L 0.558594 17.253906 Z M 14.519531 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.519531 12.511719 L 18.703125 24.832031 L 4.742188 29.574219 L 0.558594 17.253906 Z M 14.519531 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3 19 L 13 19 L 13 25 L 3 25 Z M 3 19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.519531 12.511719 L 18.703125 24.832031 L 4.742188 29.574219 L 0.558594 17.253906 Z M 14.519531 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.519531 12.511719 L 18.703125 24.832031 L 4.742188 29.574219 L 0.558594 17.253906 Z M 14.519531 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6 19 L 16 19 L 16 23 L 6 23 Z M 6 19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.519531 12.511719 L 18.703125 24.832031 L 4.742188 29.574219 L 0.558594 17.253906 Z M 14.519531 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.519531 12.511719 L 18.703125 24.832031 L 4.742188 29.574219 L 0.558594 17.253906 Z M 14.519531 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6 20 L 14 20 L 14 24 L 6 24 Z M 6 20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.519531 12.511719 L 18.703125 24.832031 L 4.742188 29.574219 L 0.558594 17.253906 Z M 14.519531 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.519531 12.511719 L 18.703125 24.832031 L 4.742188 29.574219 L 0.558594 17.253906 Z M 14.519531 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14 21 L 17 21 L 17 25 L 14 25 Z M 14 21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.519531 12.511719 L 18.703125 24.832031 L 4.742188 29.574219 L 0.558594 17.253906 Z M 14.519531 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.519531 12.511719 L 18.703125 24.832031 L 4.742188 29.574219 L 0.558594 17.253906 Z M 14.519531 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20 15 L 37 15 L 37 27 L 20 27 Z M 20 15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.777344 15.675781 L 33.976562 28.378906 L 19.578125 25.207031 L 22.378906 12.5 Z M 36.777344 15.675781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.425781 12.511719 L 19.625 25.214844 L 34.023438 28.390625 L 36.824219 15.6875 Z M 22.425781 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.421875 12.523438 L 19.625 25.207031 L 34.042969 28.386719 L 36.835938 15.703125 Z M 22.421875 12.523438"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.421875 12.523438 L 19.628906 25.203125 L 34.027344 28.378906 L 36.820312 15.699219 Z M 22.421875 12.523438"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20 15 L 36 15 L 36 26 L 20 26 Z M 20 15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.777344 15.675781 L 33.976562 28.378906 L 19.578125 25.207031 L 22.378906 12.5 Z M 36.777344 15.675781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.425781 12.511719 L 19.625 25.214844 L 34.023438 28.390625 L 36.824219 15.6875 Z M 22.425781 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32 15 L 36 15 L 36 19 L 32 19 Z M 32 15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.777344 15.675781 L 33.976562 28.378906 L 19.578125 25.207031 L 22.378906 12.5 Z M 36.777344 15.675781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.425781 12.511719 L 19.625 25.214844 L 34.023438 28.390625 L 36.824219 15.6875 Z M 22.425781 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23 17 L 33 17 L 33 21 L 23 21 Z M 23 17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.777344 15.675781 L 33.976562 28.378906 L 19.578125 25.207031 L 22.378906 12.5 Z M 36.777344 15.675781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.425781 12.511719 L 19.625 25.214844 L 34.023438 28.390625 L 36.824219 15.6875 Z M 22.425781 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25 18 L 35 18 L 35 25 L 25 25 Z M 25 18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.777344 15.675781 L 33.976562 28.378906 L 19.578125 25.207031 L 22.378906 12.5 Z M 36.777344 15.675781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.425781 12.511719 L 19.625 25.214844 L 34.023438 28.390625 L 36.824219 15.6875 Z M 22.425781 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22 18 L 32 18 L 32 23 L 22 23 Z M 22 18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.777344 15.675781 L 33.976562 28.378906 L 19.578125 25.207031 L 22.378906 12.5 Z M 36.777344 15.675781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.425781 12.511719 L 19.625 25.214844 L 34.023438 28.390625 L 36.824219 15.6875 Z M 22.425781 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 19 L 32 19 L 32 24 L 24 24 Z M 24 19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.777344 15.675781 L 33.976562 28.378906 L 19.578125 25.207031 L 22.378906 12.5 Z M 36.777344 15.675781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.425781 12.511719 L 19.625 25.214844 L 34.023438 28.390625 L 36.824219 15.6875 Z M 22.425781 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21 21 L 25 21 L 25 25 L 21 25 Z M 21 21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.777344 15.675781 L 33.976562 28.378906 L 19.578125 25.207031 L 22.378906 12.5 Z M 36.777344 15.675781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.425781 12.511719 L 19.625 25.214844 L 34.023438 28.390625 L 36.824219 15.6875 Z M 22.425781 12.511719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25 10 L 33 10 L 33 17 L 25 17 Z M 25 10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32.894531 10.257812 L 32.472656 16.746094 L 25.113281 16.269531 L 25.535156 9.777344 Z M 32.894531 10.257812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.5625 9.78125 L 25.140625 16.273438 L 32.496094 16.75 L 32.917969 10.257812 Z M 25.5625 9.78125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.5625 9.785156 L 25.140625 16.265625 L 32.503906 16.746094 L 32.925781 10.265625 Z M 25.5625 9.785156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.5625 9.785156 L 25.140625 16.265625 L 32.496094 16.742188 L 32.917969 10.265625 Z M 25.5625 9.785156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25 10 L 33 10 L 33 17 L 25 17 Z M 25 10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32.894531 10.257812 L 32.472656 16.746094 L 25.113281 16.269531 L 25.535156 9.777344 Z M 32.894531 10.257812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.5625 9.78125 L 25.140625 16.273438 L 32.496094 16.75 L 32.917969 10.257812 Z M 25.5625 9.78125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30 10 L 33 10 L 33 13 L 30 13 Z M 30 10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32.894531 10.257812 L 32.472656 16.746094 L 25.113281 16.269531 L 25.535156 9.777344 Z M 32.894531 10.257812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.5625 9.78125 L 25.140625 16.273438 L 32.496094 16.75 L 32.917969 10.257812 Z M 25.5625 9.78125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "al"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 11 L 32 11 L 32 14 L 26 14 Z M 26 11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32.894531 10.257812 L 32.472656 16.746094 L 25.113281 16.269531 L 25.535156 9.777344 Z M 32.894531 10.257812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "an"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.5625 9.78125 L 25.140625 16.273438 L 32.496094 16.75 L 32.917969 10.257812 Z M 25.5625 9.78125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27 11 L 32 11 L 32 16 L 27 16 Z M 27 11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ap"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32.894531 10.257812 L 32.472656 16.746094 L 25.113281 16.269531 L 25.535156 9.777344 Z M 32.894531 10.257812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.5625 9.78125 L 25.140625 16.273438 L 32.496094 16.75 L 32.917969 10.257812 Z M 25.5625 9.78125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 11 L 31 11 L 31 15 L 26 15 Z M 26 11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "as"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32.894531 10.257812 L 32.472656 16.746094 L 25.113281 16.269531 L 25.535156 9.777344 Z M 32.894531 10.257812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "at"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.5625 9.78125 L 25.140625 16.273438 L 32.496094 16.75 L 32.917969 10.257812 Z M 25.5625 9.78125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "au"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27 12 L 31 12 L 31 15 L 27 15 Z M 27 12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "av"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32.894531 10.257812 L 32.472656 16.746094 L 25.113281 16.269531 L 25.535156 9.777344 Z M 32.894531 10.257812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.5625 9.78125 L 25.140625 16.273438 L 32.496094 16.75 L 32.917969 10.257812 Z M 25.5625 9.78125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ax"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25 14 L 28 14 L 28 16 L 25 16 Z M 25 14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ay"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32.894531 10.257812 L 32.472656 16.746094 L 25.113281 16.269531 L 25.535156 9.777344 Z M 32.894531 10.257812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "az"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.5625 9.78125 L 25.140625 16.273438 L 32.496094 16.75 L 32.917969 10.257812 Z M 25.5625 9.78125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17 4 L 26 4 L 26 20 L 17 20 Z M 17 4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.675781 4.308594 L 29.859375 13.738281 L 19.25 20.695312 L 13.066406 11.265625 Z M 23.675781 4.308594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.042969 11.28125 L 19.226562 20.710938 L 29.832031 13.753906 L 23.648438 4.324219 Z M 13.042969 11.28125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.046875 11.289062 L 19.222656 20.703125 L 29.839844 13.738281 L 23.667969 4.324219 Z M 13.046875 11.289062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.046875 11.289062 L 19.222656 20.699219 L 29.828125 13.742188 L 23.65625 4.332031 Z M 13.046875 11.289062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17 5 L 25 5 L 25 20 L 17 20 Z M 17 5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.675781 4.308594 L 29.859375 13.738281 L 19.25 20.695312 L 13.066406 11.265625 Z M 23.675781 4.308594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.042969 11.28125 L 19.226562 20.710938 L 29.832031 13.753906 L 23.648438 4.324219 Z M 13.042969 11.28125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21 5 L 25 5 L 25 10 L 21 10 Z M 21 5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aJ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.675781 4.308594 L 29.859375 13.738281 L 19.25 20.695312 L 13.066406 11.265625 Z M 23.675781 4.308594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.042969 11.28125 L 19.226562 20.710938 L 29.832031 13.753906 L 23.648438 4.324219 Z M 13.042969 11.28125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18 7 L 23 7 L 23 16 L 18 16 Z M 18 7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.675781 4.308594 L 29.859375 13.738281 L 19.25 20.695312 L 13.066406 11.265625 Z M 23.675781 4.308594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.042969 11.28125 L 19.226562 20.710938 L 29.832031 13.753906 L 23.648438 4.324219 Z M 13.042969 11.28125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22 7 L 24 7 L 24 17 L 22 17 Z M 22 7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.675781 4.308594 L 29.859375 13.738281 L 19.25 20.695312 L 13.066406 11.265625 Z M 23.675781 4.308594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aQ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.042969 11.28125 L 19.226562 20.710938 L 29.832031 13.753906 L 23.648438 4.324219 Z M 13.042969 11.28125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19 9 L 23 9 L 23 18 L 19 18 Z M 19 9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.675781 4.308594 L 29.859375 13.738281 L 19.25 20.695312 L 13.066406 11.265625 Z M 23.675781 4.308594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.042969 11.28125 L 19.226562 20.710938 L 29.832031 13.753906 L 23.648438 4.324219 Z M 13.042969 11.28125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aU"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20 9 L 23 9 L 23 17 L 20 17 Z M 20 9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aV"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.675781 4.308594 L 29.859375 13.738281 L 19.25 20.695312 L 13.066406 11.265625 Z M 23.675781 4.308594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aW"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.042969 11.28125 L 19.226562 20.710938 L 29.832031 13.753906 L 23.648438 4.324219 Z M 13.042969 11.28125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aX"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18 17 L 22 17 L 22 19 L 18 19 Z M 18 17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aY"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.675781 4.308594 L 29.859375 13.738281 L 19.25 20.695312 L 13.066406 11.265625 Z M 23.675781 4.308594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aZ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.042969 11.28125 L 19.226562 20.710938 L 29.832031 13.753906 L 23.648438 4.324219 Z M 13.042969 11.28125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8 8 L 17 8 L 17 18 L 8 18 Z M 8 8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.882812 8.257812 L 16.902344 8.441406 L 16.699219 17.4375 L 8.679688 17.253906 Z M 8.882812 8.257812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.679688 17.285156 L 16.699219 17.464844 L 16.902344 8.46875 L 8.882812 8.289062 Z M 8.679688 17.285156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.683594 17.285156 L 16.691406 17.464844 L 16.898438 8.460938 L 8.890625 8.277344 Z M 8.683594 17.285156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.683594 17.285156 L 16.691406 17.464844 L 16.894531 8.46875 L 8.890625 8.289062 Z M 8.683594 17.285156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 8 L 17 8 L 17 18 L 9 18 Z M 9 8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.882812 8.257812 L 16.902344 8.441406 L 16.699219 17.4375 L 8.679688 17.253906 Z M 8.882812 8.257812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.679688 17.285156 L 16.699219 17.464844 L 16.902344 8.46875 L 8.882812 8.289062 Z M 8.679688 17.285156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 8 L 12 8 L 12 11 L 9 11 Z M 9 8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.882812 8.257812 L 16.902344 8.441406 L 16.699219 17.4375 L 8.679688 17.253906 Z M 8.882812 8.257812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.679688 17.285156 L 16.699219 17.464844 L 16.902344 8.46875 L 8.882812 8.289062 Z M 8.679688 17.285156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10 10 L 14 10 L 14 16 L 10 16 Z M 10 10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.882812 8.257812 L 16.902344 8.441406 L 16.699219 17.4375 L 8.679688 17.253906 Z M 8.882812 8.257812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.679688 17.285156 L 16.699219 17.464844 L 16.902344 8.46875 L 8.882812 8.289062 Z M 8.679688 17.285156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11 9 L 16 9 L 16 15 L 11 15 Z M 11 9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.882812 8.257812 L 16.902344 8.441406 L 16.699219 17.4375 L 8.679688 17.253906 Z M 8.882812 8.257812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.679688 17.285156 L 16.699219 17.464844 L 16.902344 8.46875 L 8.882812 8.289062 Z M 8.679688 17.285156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "br"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11 11 L 15 11 L 15 16 L 11 16 Z M 11 11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.882812 8.257812 L 16.902344 8.441406 L 16.699219 17.4375 L 8.679688 17.253906 Z M 8.882812 8.257812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.679688 17.285156 L 16.699219 17.464844 L 16.902344 8.46875 L 8.882812 8.289062 Z M 8.679688 17.285156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11 11 L 15 11 L 15 15 L 11 15 Z M 11 11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.882812 8.257812 L 16.902344 8.441406 L 16.699219 17.4375 L 8.679688 17.253906 Z M 8.882812 8.257812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.679688 17.285156 L 16.699219 17.464844 L 16.902344 8.46875 L 8.882812 8.289062 Z M 8.679688 17.285156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14 14 L 16 14 L 16 17 L 14 17 Z M 14 14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "by"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.882812 8.257812 L 16.902344 8.441406 L 16.699219 17.4375 L 8.679688 17.253906 Z M 8.882812 8.257812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.679688 17.285156 L 16.699219 17.464844 L 16.902344 8.46875 L 8.882812 8.289062 Z M 8.679688 17.285156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4 12 L 11 12 L 11 17 L 4 17 Z M 4 12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.433594 13.25 L 8.492188 11.1875 L 10.851562 15.828125 L 6.792969 17.890625 Z M 4.433594 13.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.785156 17.875 L 10.84375 15.8125 L 8.484375 11.171875 L 4.425781 13.238281 Z M 6.785156 17.875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.789062 17.875 L 10.839844 15.8125 L 8.480469 11.167969 L 4.425781 13.230469 Z M 6.789062 17.875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.789062 17.875 L 10.839844 15.8125 L 8.480469 11.175781 L 4.429688 13.234375 Z M 6.789062 17.875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4 13 L 11 13 L 11 17 L 4 17 Z M 4 13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.433594 13.25 L 8.492188 11.1875 L 10.851562 15.828125 L 6.792969 17.890625 Z M 4.433594 13.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.785156 17.875 L 10.84375 15.8125 L 8.484375 11.171875 L 4.425781 13.238281 Z M 6.785156 17.875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4 13 L 7 13 L 7 15 L 4 15 Z M 4 13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bJ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.433594 13.25 L 8.492188 11.1875 L 10.851562 15.828125 L 6.792969 17.890625 Z M 4.433594 13.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.785156 17.875 L 10.84375 15.8125 L 8.484375 11.171875 L 4.425781 13.238281 Z M 6.785156 17.875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5 13 L 9 13 L 9 16 L 5 16 Z M 5 13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.433594 13.25 L 8.492188 11.1875 L 10.851562 15.828125 L 6.792969 17.890625 Z M 4.433594 13.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.785156 17.875 L 10.84375 15.8125 L 8.484375 11.171875 L 4.425781 13.238281 Z M 6.785156 17.875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5 13 L 10 13 L 10 15 L 5 15 Z M 5 13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.433594 13.25 L 8.492188 11.1875 L 10.851562 15.828125 L 6.792969 17.890625 Z M 4.433594 13.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bQ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.785156 17.875 L 10.84375 15.8125 L 8.484375 11.171875 L 4.425781 13.238281 Z M 6.785156 17.875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6 14 L 10 14 L 10 16 L 6 16 Z M 6 14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.433594 13.25 L 8.492188 11.1875 L 10.851562 15.828125 L 6.792969 17.890625 Z M 4.433594 13.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.785156 17.875 L 10.84375 15.8125 L 8.484375 11.171875 L 4.425781 13.238281 Z M 6.785156 17.875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bU"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6 13 L 10 13 L 10 15 L 6 15 Z M 6 13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bV"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.433594 13.25 L 8.492188 11.1875 L 10.851562 15.828125 L 6.792969 17.890625 Z M 4.433594 13.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bW"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.785156 17.875 L 10.84375 15.8125 L 8.484375 11.171875 L 4.425781 13.238281 Z M 6.785156 17.875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bX"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 14 L 11 14 L 11 17 L 9 17 Z M 9 14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bY"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.433594 13.25 L 8.492188 11.1875 L 10.851562 15.828125 L 6.792969 17.890625 Z M 4.433594 13.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bZ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.785156 17.875 L 10.84375 15.8125 L 8.484375 11.171875 L 4.425781 13.238281 Z M 6.785156 17.875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14 4 L 18 4 L 18 12 L 14 12 Z M 14 4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.34375 4.074219 L 19.804688 6.753906 L 16.792969 11.773438 L 12.332031 9.09375 Z M 15.34375 4.074219"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.347656 9.070312 L 16.808594 11.75 L 19.820312 6.730469 L 15.359375 4.050781 Z M 12.347656 9.070312"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.351562 9.074219 L 16.804688 11.746094 L 19.820312 6.722656 L 15.367188 4.046875 Z M 12.351562 9.074219"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.351562 9.074219 L 16.804688 11.746094 L 19.816406 6.726562 L 15.363281 4.054688 Z M 12.351562 9.074219"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14 4 L 18 4 L 18 12 L 14 12 Z M 14 4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.34375 4.074219 L 19.804688 6.753906 L 16.792969 11.773438 L 12.332031 9.09375 Z M 15.34375 4.074219"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.347656 9.070312 L 16.808594 11.75 L 19.820312 6.730469 L 15.359375 4.050781 Z M 12.347656 9.070312"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ci"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15 4 L 17 4 L 17 7 L 15 7 Z M 15 4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.34375 4.074219 L 19.804688 6.753906 L 16.792969 11.773438 L 12.332031 9.09375 Z M 15.34375 4.074219"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ck"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.347656 9.070312 L 16.808594 11.75 L 19.820312 6.730469 L 15.359375 4.050781 Z M 12.347656 9.070312"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15 5 L 16 5 L 16 10 L 15 10 Z M 15 5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.34375 4.074219 L 19.804688 6.753906 L 16.792969 11.773438 L 12.332031 9.09375 Z M 15.34375 4.074219"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.347656 9.070312 L 16.808594 11.75 L 19.820312 6.730469 L 15.359375 4.050781 Z M 12.347656 9.070312"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "co"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16 5 L 18 5 L 18 10 L 16 10 Z M 16 5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.34375 4.074219 L 19.804688 6.753906 L 16.792969 11.773438 L 12.332031 9.09375 Z M 15.34375 4.074219"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.347656 9.070312 L 16.808594 11.75 L 19.820312 6.730469 L 15.359375 4.050781 Z M 12.347656 9.070312"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15 6 L 17 6 L 17 11 L 15 11 Z M 15 6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.34375 4.074219 L 19.804688 6.753906 L 16.792969 11.773438 L 12.332031 9.09375 Z M 15.34375 4.074219"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ct"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.347656 9.070312 L 16.808594 11.75 L 19.820312 6.730469 L 15.359375 4.050781 Z M 12.347656 9.070312"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16 6 L 17 6 L 17 10 L 16 10 Z M 16 6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.34375 4.074219 L 19.804688 6.753906 L 16.792969 11.773438 L 12.332031 9.09375 Z M 15.34375 4.074219"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.347656 9.070312 L 16.808594 11.75 L 19.820312 6.730469 L 15.359375 4.050781 Z M 12.347656 9.070312"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15 9 L 18 9 L 18 11 L 15 11 Z M 15 9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.34375 4.074219 L 19.804688 6.753906 L 16.792969 11.773438 L 12.332031 9.09375 Z M 15.34375 4.074219"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.347656 9.070312 L 16.808594 11.75 L 19.820312 6.730469 L 15.359375 4.050781 Z M 12.347656 9.070312"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BB3237",
    d: "M 1.015625 17.476562 C 1.113281 17.277344 1.324219 17.011719 1.761719 16.855469 C 2.183594 16.710938 2.605469 16.703125 3.035156 16.707031 C 5.230469 16.730469 7.441406 16.925781 9.605469 17.277344 C 9.792969 17.308594 9.980469 17.335938 10.175781 17.367188 C 10.996094 17.488281 11.84375 17.617188 12.621094 17.910156 C 13.496094 18.238281 14.296875 18.757812 15.074219 19.257812 C 15.242188 19.363281 15.410156 19.472656 15.578125 19.578125 C 16.15625 19.941406 16.953125 20.441406 17.417969 21.230469 C 17.90625 22.0625 17.957031 23.140625 17.558594 24.046875 C 17.539062 24.089844 17.519531 24.132812 17.496094 24.175781 C 17.09375 24.984375 16.359375 25.617188 15.476562 25.914062 C 14.539062 26.226562 13.546875 26.136719 12.609375 26.019531 C 11.613281 25.890625 10.460938 25.722656 9.390625 25.3125 C 7.351562 24.53125 5.730469 23.601562 4.4375 22.476562 L 4.351562 22.402344 C 3.960938 22.0625 2.914062 21.15625 2.101562 20.230469 C 1.425781 19.46875 0.582031 18.347656 1.015625 17.476562"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BB3237",
    d: "M 2.550781 19.839844 C 3.402344 20.804688 4.507812 21.746094 4.832031 22.027344 C 6.234375 23.246094 7.882812 24.09375 9.605469 24.753906 C 10.589844 25.132812 11.640625 25.292969 12.6875 25.425781 C 13.554688 25.539062 14.457031 25.625 15.289062 25.347656 C 16.039062 25.097656 16.691406 24.53125 17.007812 23.808594 C 17.328125 23.085938 17.300781 22.214844 16.902344 21.53125 C 16.527344 20.898438 15.882812 20.472656 15.253906 20.082031 C 14.355469 19.515625 13.40625 18.84375 12.410156 18.46875 C 11.511719 18.128906 10.453125 18.019531 9.507812 17.867188 C 7.367188 17.515625 5.195312 17.328125 3.027344 17.300781 C 2.664062 17.296875 2.296875 17.300781 1.957031 17.417969 C 1.027344 17.746094 1.644531 18.808594 2.550781 19.839844"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BB3237",
    d: "M 3.058594 20.195312 C 3.394531 19.976562 2.480469 19.226562 2.714844 19.070312 C 3.050781 18.851562 5.371094 20.085938 5.5625 19.699219 C 5.769531 19.285156 3.226562 18.269531 3.199219 17.875 C 3.175781 17.59375 4.503906 17.746094 4.433594 17.429688 C 4.429688 17.394531 4.414062 17.367188 4.390625 17.339844 C 3.9375 17.320312 3.480469 17.308594 3.027344 17.300781 C 2.664062 17.296875 2.296875 17.300781 1.957031 17.417969 C 1.027344 17.746094 1.644531 18.808594 2.550781 19.839844 C 2.667969 19.972656 2.789062 20.101562 2.910156 20.234375 C 2.964844 20.234375 3.015625 20.226562 3.058594 20.195312"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 14.53125 20.863281 C 11.675781 18.757812 7.832031 19.472656 4.589844 18.191406 C 7.539062 18.730469 12.4375 18.652344 14.53125 20.863281"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 12.699219 24.265625 C 10.148438 24.800781 5.34375 21.402344 3.535156 19.960938 C 6.386719 21.375 9.441406 24.039062 12.699219 24.265625"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 15.296875 22.554688 C 12.121094 22.246094 8.824219 20.792969 6.082031 19.277344 C 9.054688 20.070312 11.765625 21.839844 15.296875 22.554688"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 13.789062 23.484375 C 11.386719 23.585938 7.894531 21.300781 6.152344 20.191406 C 8.765625 21.089844 10.921875 23.007812 13.789062 23.484375"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 16.253906 21.488281 C 16.929688 21.90625 17.222656 24.859375 14.113281 24.742188 C 16.019531 24.273438 15.832031 21.226562 16.253906 21.488281"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#D)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C2CB",
    d: "M 36.390625 15.957031 C 36.273438 15.773438 36.035156 15.53125 35.582031 15.425781 C 35.148438 15.324219 34.730469 15.363281 34.300781 15.414062 C 32.125 15.683594 29.945312 16.117188 27.832031 16.707031 C 27.652344 16.757812 27.464844 16.808594 27.277344 16.859375 C 26.476562 17.070312 25.644531 17.289062 24.90625 17.667969 C 24.074219 18.09375 23.332031 18.695312 22.617188 19.277344 C 22.460938 19.402344 22.304688 19.527344 22.152344 19.648438 C 21.613281 20.078125 20.878906 20.660156 20.503906 21.496094 C 20.113281 22.375 20.179688 23.453125 20.675781 24.3125 C 20.699219 24.355469 20.726562 24.394531 20.75 24.433594 C 21.238281 25.191406 22.039062 25.738281 22.949219 25.9375 C 23.917969 26.144531 24.894531 25.945312 25.8125 25.726562 C 26.789062 25.488281 27.910156 25.195312 28.933594 24.667969 C 30.871094 23.667969 32.382812 22.566406 33.542969 21.304688 L 33.621094 21.222656 C 33.972656 20.839844 34.910156 19.824219 35.621094 18.816406 C 36.203125 17.980469 36.921875 16.777344 36.390625 15.957031"
  }))))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#F)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#G)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#H)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C2CB",
    d: "M 35.128906 18.476562 C 34.390625 19.53125 33.394531 20.585938 33.101562 20.902344 C 31.84375 22.265625 30.296875 23.292969 28.65625 24.140625 C 27.722656 24.621094 26.695312 24.898438 25.671875 25.148438 C 24.820312 25.351562 23.929688 25.539062 23.074219 25.355469 C 22.300781 25.1875 21.589844 24.699219 21.195312 24.015625 C 20.796875 23.332031 20.730469 22.460938 21.050781 21.742188 C 21.351562 21.066406 21.949219 20.574219 22.527344 20.117188 C 23.359375 19.453125 24.226562 18.683594 25.179688 18.199219 C 26.03125 17.761719 27.070312 17.539062 27.996094 17.28125 C 30.085938 16.695312 32.222656 16.269531 34.375 16.007812 C 34.734375 15.964844 35.097656 15.925781 35.449219 16.003906 C 36.414062 16.226562 35.917969 17.351562 35.128906 18.476562"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#I)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#J)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#K)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C2CB",
    d: "M 34.660156 18.886719 C 34.304688 18.707031 35.132812 17.859375 34.878906 17.730469 C 34.523438 17.550781 32.351562 19.03125 32.117188 18.667969 C 31.867188 18.28125 34.28125 16.992188 34.269531 16.59375 C 34.257812 16.3125 32.957031 16.613281 32.988281 16.285156 C 32.992188 16.253906 33.003906 16.222656 33.023438 16.195312 C 33.472656 16.125 33.925781 16.0625 34.375 16.007812 C 34.734375 15.964844 35.097656 15.925781 35.449219 16.003906 C 36.414062 16.226562 35.917969 17.351562 35.128906 18.476562 C 35.027344 18.621094 34.921875 18.765625 34.8125 18.90625 C 34.757812 18.914062 34.707031 18.910156 34.660156 18.886719"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#L)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#M)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#N)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 23.335938 20.8125 C 25.9375 18.40625 29.835938 18.695312 32.921875 17.0625 C 30.046875 17.925781 25.171875 18.386719 23.335938 20.8125"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#O)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#P)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 25.527344 23.992188 C 28.121094 24.242188 32.523438 20.335938 34.164062 18.703125 C 31.484375 20.421875 28.742188 23.410156 25.527344 23.992188"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#R)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#S)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#T)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 22.757812 22.582031 C 25.882812 21.921875 28.996094 20.113281 31.554688 18.304688 C 28.6875 19.421875 26.1875 21.480469 22.757812 22.582031"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#U)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#V)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#W)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 24.359375 23.335938 C 26.757812 23.171875 29.976562 20.519531 31.585938 19.222656 C 29.089844 20.40625 27.15625 22.546875 24.359375 23.335938"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#X)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Y)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 21.6875 21.625 C 21.066406 22.113281 21.097656 25.082031 24.175781 24.625 C 22.230469 24.363281 22.082031 21.320312 21.6875 21.625"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C2CB",
    d: "M 32.726562 10.425781 C 32.652344 10.34375 32.515625 10.238281 32.285156 10.222656 C 32.0625 10.207031 31.859375 10.257812 31.652344 10.316406 C 30.59375 10.613281 29.550781 10.992188 28.550781 11.445312 C 28.464844 11.484375 28.378906 11.519531 28.289062 11.558594 C 27.910156 11.726562 27.515625 11.898438 27.179688 12.140625 C 26.800781 12.414062 26.480469 12.765625 26.167969 13.109375 C 26.101562 13.183594 26.035156 13.257812 25.96875 13.328125 C 25.734375 13.582031 25.414062 13.925781 25.292969 14.367188 C 25.164062 14.832031 25.28125 15.359375 25.589844 15.746094 C 25.605469 15.765625 25.621094 15.78125 25.636719 15.800781 C 25.9375 16.136719 26.375 16.347656 26.835938 16.375 C 27.332031 16.40625 27.800781 16.234375 28.238281 16.054688 C 28.699219 15.863281 29.234375 15.632812 29.699219 15.296875 C 30.582031 14.652344 31.242188 13.996094 31.722656 13.28125 L 31.753906 13.238281 C 31.898438 13.023438 32.285156 12.449219 32.558594 11.894531 C 32.785156 11.441406 33.046875 10.789062 32.726562 10.425781"
  }))))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ag)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ah)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C2CB",
    d: "M 32.292969 11.765625 C 32.007812 12.34375 31.59375 12.941406 31.472656 13.117188 C 30.957031 13.886719 30.269531 14.511719 29.523438 15.054688 C 29.097656 15.363281 28.609375 15.578125 28.121094 15.777344 C 27.71875 15.945312 27.292969 16.105469 26.855469 16.078125 C 26.460938 16.054688 26.074219 15.867188 25.824219 15.558594 C 25.578125 15.25 25.476562 14.824219 25.582031 14.445312 C 25.679688 14.089844 25.9375 13.800781 26.1875 13.53125 C 26.550781 13.140625 26.917969 12.695312 27.351562 12.382812 C 27.742188 12.101562 28.238281 11.914062 28.675781 11.714844 C 29.664062 11.269531 30.6875 10.894531 31.734375 10.601562 C 31.90625 10.554688 32.082031 10.507812 32.261719 10.519531 C 32.757812 10.554688 32.597656 11.148438 32.292969 11.765625"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aj)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ak)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C2CB",
    d: "M 32.089844 12.003906 C 31.902344 11.941406 32.246094 11.460938 32.113281 11.417969 C 31.921875 11.355469 30.960938 12.25 30.820312 12.089844 C 30.664062 11.914062 31.761719 11.09375 31.722656 10.898438 C 31.695312 10.761719 31.078125 11.007812 31.070312 10.84375 C 31.066406 10.828125 31.070312 10.8125 31.078125 10.796875 C 31.296875 10.730469 31.511719 10.664062 31.734375 10.601562 C 31.90625 10.554688 32.082031 10.507812 32.261719 10.519531 C 32.757812 10.554688 32.597656 11.148438 32.292969 11.765625 C 32.253906 11.84375 32.210938 11.921875 32.167969 12 C 32.140625 12.011719 32.117188 12.011719 32.089844 12.003906"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#al)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#am)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#an)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 26.640625 13.8125 C 27.746094 12.425781 29.695312 12.273438 31.09375 11.234375 C 29.738281 11.878906 27.363281 12.476562 26.640625 13.8125"
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ao)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ap)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 27.964844 15.21875 C 29.265625 15.144531 31.144531 12.882812 31.832031 11.949219 C 30.640625 13.003906 29.507812 14.6875 27.964844 15.21875"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ar)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#as)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#at)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 26.488281 14.730469 C 27.984375 14.171875 29.386719 13.039062 30.511719 11.953125 C 29.179688 12.722656 28.101562 13.925781 26.488281 14.730469"
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#au)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#av)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aw)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 27.339844 14.984375 C 28.511719 14.722656 29.902344 13.164062 30.597656 12.402344 C 29.453125 13.175781 28.660156 14.382812 27.339844 14.984375"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ax)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ay)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#az)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 25.886719 14.339844 C 25.617188 14.628906 25.859375 16.09375 27.34375 15.632812 C 26.363281 15.652344 26.058594 14.160156 25.886719 14.339844"
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aA)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aB)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aC)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aD)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BB3237",
    d: "M 23.558594 4.753906 C 23.371094 4.714844 23.078125 4.714844 22.742188 4.929688 C 22.421875 5.136719 22.191406 5.421875 21.96875 5.714844 C 20.824219 7.222656 19.789062 8.828125 18.886719 10.488281 C 18.808594 10.632812 18.726562 10.777344 18.644531 10.921875 C 18.296875 11.546875 17.933594 12.191406 17.722656 12.878906 C 17.488281 13.648438 17.414062 14.46875 17.34375 15.261719 C 17.328125 15.4375 17.316406 15.609375 17.296875 15.777344 C 17.238281 16.367188 17.160156 17.175781 17.453125 17.914062 C 17.761719 18.6875 18.46875 19.300781 19.296875 19.511719 C 19.339844 19.523438 19.378906 19.53125 19.417969 19.539062 C 20.179688 19.699219 21 19.539062 21.667969 19.097656 C 22.378906 18.625 22.84375 17.902344 23.253906 17.203125 C 23.695312 16.457031 24.1875 15.585938 24.472656 14.636719 C 25.019531 12.832031 25.242188 11.234375 25.160156 9.753906 L 25.152344 9.65625 C 25.128906 9.207031 25.066406 8.011719 24.863281 6.964844 C 24.699219 6.097656 24.382812 4.925781 23.558594 4.753906"
  }))))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aF)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aG)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aH)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BB3237",
    d: "M 24.359375 7.0625 C 24.566406 8.15625 24.625 9.410156 24.644531 9.78125 C 24.734375 11.386719 24.441406 12.960938 23.980469 14.488281 C 23.71875 15.355469 23.273438 16.15625 22.8125 16.9375 C 22.429688 17.589844 22.011719 18.25 21.382812 18.664062 C 20.8125 19.042969 20.085938 19.183594 19.425781 19.011719 C 18.765625 18.84375 18.183594 18.355469 17.929688 17.722656 C 17.695312 17.128906 17.746094 16.464844 17.8125 15.828125 C 17.902344 14.914062 17.945312 13.910156 18.214844 13.03125 C 18.460938 12.238281 18.945312 11.464844 19.339844 10.734375 C 20.230469 9.09375 21.25 7.515625 22.378906 6.027344 C 22.566406 5.78125 22.761719 5.53125 23.023438 5.363281 C 23.738281 4.90625 24.136719 5.894531 24.359375 7.0625"
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aJ)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aK)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BB3237",
    d: "M 24.332031 7.597656 C 24.007812 7.707031 23.980469 6.683594 23.75 6.761719 C 23.421875 6.875 23.035156 9.109375 22.671875 9.035156 C 22.28125 8.953125 22.933594 6.683594 22.675781 6.449219 C 22.496094 6.289062 21.902344 7.269531 21.71875 7.054688 C 21.703125 7.03125 21.691406 7.003906 21.683594 6.976562 C 21.910156 6.65625 22.140625 6.339844 22.378906 6.027344 C 22.566406 5.78125 22.761719 5.53125 23.023438 5.363281 C 23.738281 4.90625 24.136719 5.894531 24.359375 7.0625 C 24.386719 7.210938 24.414062 7.363281 24.4375 7.515625 C 24.410156 7.554688 24.375 7.585938 24.332031 7.597656"
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aL)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aM)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aN)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 18.726562 15.753906 C 18.800781 12.6875 21.320312 10.457031 22.160156 7.566406 C 20.96875 9.859375 18.328125 13.148438 18.726562 15.753906"
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aO)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aP)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 22.011719 16.328125 C 23.722656 14.878906 23.945312 9.796875 23.921875 7.792969 C 23.378906 10.488281 23.578125 13.992188 22.011719 16.328125"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aR)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aS)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aT)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 19.476562 17.179688 C 20.945312 14.855469 21.691406 11.835938 22.109375 9.164062 C 21.078125 11.609375 20.851562 14.394531 19.476562 17.179688"
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aU)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aV)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 20.90625 16.648438 C 22.242188 15.070312 22.53125 11.476562 22.695312 9.699219 C 21.929688 11.953125 22.09375 14.445312 20.90625 16.648438"
  }))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aX)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aY)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 18.242188 17.261719 C 18.171875 17.941406 20.027344 19.71875 21.59375 17.542969 C 20.261719 18.585938 18.289062 16.832031 18.242188 17.261719"
  }))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#be)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C2CB",
    d: "M 9.097656 8.515625 C 9 8.605469 8.878906 8.777344 8.871094 9.0625 C 8.863281 9.332031 8.9375 9.578125 9.019531 9.828125 C 9.441406 11.101562 9.960938 12.355469 10.570312 13.550781 C 10.625 13.652344 10.675781 13.757812 10.726562 13.867188 C 10.953125 14.320312 11.183594 14.792969 11.503906 15.191406 C 11.859375 15.640625 12.308594 16.011719 12.746094 16.375 C 12.84375 16.453125 12.9375 16.53125 13.027344 16.605469 C 13.351562 16.878906 13.792969 17.25 14.34375 17.375 C 14.921875 17.507812 15.566406 17.34375 16.027344 16.941406 C 16.046875 16.921875 16.070312 16.902344 16.089844 16.882812 C 16.492188 16.503906 16.726562 15.957031 16.738281 15.390625 C 16.75 14.785156 16.511719 14.222656 16.269531 13.699219 C 16.011719 13.144531 15.699219 12.503906 15.257812 11.957031 C 14.421875 10.914062 13.574219 10.136719 12.671875 9.589844 L 12.613281 9.554688 C 12.339844 9.386719 11.613281 8.945312 10.917969 8.640625 C 10.34375 8.390625 9.53125 8.101562 9.097656 8.515625"
  }))))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bg)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bh)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C2CB",
    d: "M 10.769531 8.976562 C 11.496094 9.292969 12.253906 9.765625 12.480469 9.902344 C 13.457031 10.496094 14.261719 11.300781 14.96875 12.183594 C 15.375 12.6875 15.664062 13.269531 15.9375 13.855469 C 16.160156 14.339844 16.382812 14.847656 16.371094 15.382812 C 16.363281 15.867188 16.152344 16.347656 15.785156 16.667969 C 15.417969 16.984375 14.898438 17.128906 14.425781 17.019531 C 13.980469 16.917969 13.613281 16.621094 13.265625 16.328125 C 12.765625 15.90625 12.195312 15.480469 11.789062 14.964844 C 11.425781 14.503906 11.164062 13.910156 10.898438 13.386719 C 10.296875 12.203125 9.785156 10.976562 9.367188 9.714844 C 9.296875 9.507812 9.230469 9.292969 9.238281 9.074219 C 9.257812 8.46875 9.996094 8.636719 10.769531 8.976562"
  }))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bi)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bj)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bk)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C2CB",
    d: "M 11.074219 9.207031 C 11.007812 9.441406 10.398438 9.046875 10.351562 9.210938 C 10.285156 9.445312 11.4375 10.574219 11.246094 10.753906 C 11.042969 10.949219 9.972656 9.65625 9.734375 9.710938 C 9.566406 9.75 9.902344 10.492188 9.703125 10.511719 C 9.683594 10.515625 9.664062 10.511719 9.644531 10.503906 C 9.546875 10.242188 9.453125 9.980469 9.367188 9.714844 C 9.296875 9.507812 9.230469 9.292969 9.238281 9.074219 C 9.257812 8.46875 9.996094 8.636719 10.769531 8.976562 C 10.871094 9.019531 10.972656 9.066406 11.070312 9.113281 C 11.082031 9.144531 11.085938 9.175781 11.074219 9.207031"
  }))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bl)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bm)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bn)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 13.59375 15.761719 C 11.824219 14.488281 11.535156 12.117188 10.179688 10.460938 C 11.042969 12.082031 11.902344 14.949219 13.59375 15.761719"
  }))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bo)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bp)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 15.253906 14.074219 C 15.097656 12.492188 12.207031 10.316406 11.023438 9.523438 C 12.382812 10.925781 14.519531 12.21875 15.253906 14.074219"
  }))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#br)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bs)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bt)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 14.730469 15.898438 C 13.960938 14.105469 12.492188 12.453125 11.09375 11.136719 C 12.113281 12.71875 13.65625 13.976562 14.730469 15.898438"
  }))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bv)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bw)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 14.996094 14.851562 C 14.613281 13.433594 12.621094 11.820312 11.644531 11.007812 C 12.660156 12.363281 14.183594 13.269531 14.996094 14.851562"
  }))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bx)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#by)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bz)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 14.28125 16.652344 C 14.652344 16.96875 16.441406 16.597656 15.796875 14.808594 C 15.871094 16.003906 14.046875 16.453125 14.28125 16.652344"
  }))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bA)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bB)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bC)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bD)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C2CB",
    d: "M 4.59375 13.292969 C 4.570312 13.367188 4.558594 13.488281 4.632812 13.632812 C 4.703125 13.773438 4.804688 13.882812 4.914062 13.984375 C 5.476562 14.523438 6.078125 15.019531 6.710938 15.464844 C 6.765625 15.503906 6.820312 15.542969 6.875 15.582031 C 7.113281 15.753906 7.355469 15.933594 7.625 16.050781 C 7.925781 16.183594 8.253906 16.25 8.570312 16.316406 C 8.640625 16.332031 8.707031 16.347656 8.773438 16.363281 C 9.007812 16.414062 9.332031 16.484375 9.640625 16.398438 C 9.96875 16.3125 10.242188 16.054688 10.363281 15.726562 C 10.371094 15.710938 10.375 15.695312 10.378906 15.679688 C 10.476562 15.378906 10.445312 15.035156 10.296875 14.746094 C 10.136719 14.433594 9.863281 14.210938 9.597656 14.007812 C 9.316406 13.796875 8.988281 13.554688 8.617188 13.390625 C 7.914062 13.085938 7.277344 12.917969 6.675781 12.882812 L 6.636719 12.878906 C 6.457031 12.867188 5.972656 12.835938 5.539062 12.867188 C 5.183594 12.894531 4.699219 12.96875 4.59375 13.292969"
  }))))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bF)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bG)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bH)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C2CB",
    d: "M 5.558594 13.078125 C 6.007812 13.046875 6.515625 13.082031 6.667969 13.09375 C 7.316406 13.132812 7.941406 13.324219 8.535156 13.585938 C 8.875 13.734375 9.179688 13.953125 9.472656 14.175781 C 9.71875 14.363281 9.96875 14.5625 10.109375 14.839844 C 10.238281 15.089844 10.265625 15.390625 10.167969 15.652344 C 10.074219 15.910156 9.851562 16.125 9.585938 16.195312 C 9.335938 16.265625 9.070312 16.210938 8.816406 16.15625 C 8.453125 16.074219 8.050781 16.011719 7.707031 15.859375 C 7.398438 15.722656 7.105469 15.488281 6.828125 15.292969 C 6.203125 14.851562 5.613281 14.363281 5.058594 13.835938 C 4.96875 13.746094 4.875 13.65625 4.820312 13.542969 C 4.664062 13.230469 5.078125 13.113281 5.558594 13.078125"
  }))))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bI)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bJ)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bK)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C2CB",
    d: "M 5.773438 13.113281 C 5.804688 13.253906 5.390625 13.214844 5.414062 13.3125 C 5.445312 13.449219 6.328125 13.714844 6.285156 13.859375 C 6.234375 14.011719 5.347656 13.640625 5.242188 13.734375 C 5.167969 13.796875 5.539062 14.085938 5.445312 14.152344 C 5.433594 14.15625 5.425781 14.160156 5.414062 14.160156 C 5.292969 14.054688 5.175781 13.945312 5.058594 13.835938 C 4.96875 13.746094 4.875 13.65625 4.820312 13.542969 C 4.664062 13.230469 5.078125 13.113281 5.558594 13.078125 C 5.621094 13.074219 5.683594 13.070312 5.746094 13.070312 C 5.761719 13.082031 5.769531 13.097656 5.773438 13.113281"
  }))))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bL)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bM)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bN)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 8.824219 15.78125 C 7.59375 15.605469 6.800781 14.476562 5.671875 13.996094 C 6.542969 14.589844 7.757812 15.820312 8.824219 15.78125"
  }))))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bO)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bP)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 9.195312 14.472656 C 8.683594 13.707031 6.644531 13.375 5.835938 13.292969 C 6.898438 13.640625 8.320312 13.726562 9.195312 14.472656"
  }))))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bR)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bS)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bT)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 9.429688 15.542969 C 8.554688 14.835938 7.371094 14.390625 6.3125 14.09375 C 7.253906 14.628906 8.367188 14.851562 9.429688 15.542969"
  }))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bU)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bV)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 9.277344 14.9375 C 8.699219 14.320312 7.261719 14.03125 6.550781 13.878906 C 7.429688 14.296875 8.441406 14.351562 9.277344 14.9375"
  }))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bX)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bY)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 9.414062 16.046875 C 9.683594 16.109375 10.480469 15.441406 9.667969 14.699219 C 10.03125 15.289062 9.242188 16.007812 9.414062 16.046875"
  }))))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ca)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ce)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BB3237",
    d: "M 15.40625 4.25 C 15.320312 4.269531 15.199219 4.328125 15.105469 4.484375 C 15.011719 4.636719 14.972656 4.800781 14.9375 4.964844 C 14.765625 5.820312 14.65625 6.695312 14.617188 7.570312 C 14.613281 7.644531 14.605469 7.71875 14.601562 7.796875 C 14.582031 8.125 14.5625 8.46875 14.613281 8.792969 C 14.667969 9.164062 14.800781 9.519531 14.933594 9.863281 C 14.960938 9.9375 14.988281 10.011719 15.015625 10.085938 C 15.109375 10.34375 15.238281 10.695312 15.507812 10.941406 C 15.792969 11.203125 16.210938 11.316406 16.597656 11.238281 C 16.617188 11.234375 16.632812 11.230469 16.652344 11.222656 C 17 11.136719 17.308594 10.90625 17.5 10.589844 C 17.699219 10.25 17.746094 9.855469 17.777344 9.480469 C 17.8125 9.085938 17.839844 8.625 17.769531 8.171875 C 17.632812 7.3125 17.40625 6.605469 17.074219 6.003906 L 17.054688 5.964844 C 16.953125 5.785156 16.6875 5.300781 16.394531 4.90625 C 16.152344 4.578125 15.785156 4.152344 15.40625 4.25"
  }))))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cg)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ch)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BB3237",
    d: "M 16.203125 5.046875 C 16.507812 5.460938 16.785156 5.96875 16.867188 6.117188 C 17.226562 6.769531 17.421875 7.480469 17.535156 8.207031 C 17.601562 8.621094 17.574219 9.042969 17.542969 9.460938 C 17.511719 9.808594 17.472656 10.167969 17.292969 10.464844 C 17.132812 10.738281 16.859375 10.941406 16.550781 11.003906 C 16.242188 11.066406 15.902344 10.980469 15.671875 10.765625 C 15.453125 10.566406 15.339844 10.28125 15.238281 10.003906 C 15.09375 9.605469 14.910156 9.179688 14.847656 8.757812 C 14.789062 8.382812 14.835938 7.960938 14.851562 7.582031 C 14.894531 6.71875 15 5.859375 15.171875 5.015625 C 15.199219 4.875 15.230469 4.730469 15.308594 4.609375 C 15.511719 4.273438 15.875 4.605469 16.203125 5.046875"
  }))))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ci)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cj)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ck)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BB3237",
    d: "M 16.300781 5.273438 C 16.1875 5.386719 15.96875 4.964844 15.890625 5.042969 C 15.777344 5.15625 16.0625 6.164062 15.898438 6.203125 C 15.71875 6.25 15.535156 5.175781 15.382812 5.128906 C 15.273438 5.097656 15.222656 5.625 15.105469 5.574219 C 15.09375 5.566406 15.082031 5.558594 15.074219 5.546875 C 15.105469 5.371094 15.136719 5.191406 15.171875 5.015625 C 15.199219 4.875 15.230469 4.730469 15.308594 4.609375 C 15.511719 4.273438 15.875 4.605469 16.203125 5.046875 C 16.246094 5.101562 16.285156 5.160156 16.324219 5.21875 C 16.324219 5.242188 16.3125 5.261719 16.300781 5.273438"
  }))))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cl)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cm)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cn)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 15.605469 9.789062 C 15.019531 8.5 15.621094 7.066406 15.390625 5.695312 C 15.355469 6.890625 14.917969 8.785156 15.605469 9.789062"
  }))))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#co)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 17.085938 9.367188 C 17.507812 8.421875 16.578125 6.265625 16.167969 5.4375 C 16.484375 6.667969 17.269531 8.082031 17.085938 9.367188"
  }))))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cr)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cs)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ct)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 16.203125 10.230469 C 16.347656 8.96875 16.050781 7.566406 15.6875 6.371094 C 15.75 7.59375 16.214844 8.796875 16.203125 10.230469"
  }))))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cu)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cv)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cw)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 16.691406 9.722656 C 16.929688 8.800781 16.328125 7.246094 16.039062 6.476562 C 16.175781 7.566406 16.742188 8.570312 16.691406 9.722656"
  }))))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cx)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cy)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cz)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M 15.707031 10.511719 C 15.8125 10.808594 16.941406 11.175781 17.15625 9.957031 C 16.8125 10.65625 15.640625 10.324219 15.707031 10.511719"
  }))))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    fill: "#00C2CB"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.328125 1.046875 C 2.203125 1.046875 2.078125 1.007812 1.953125 0.9375 C 1.835938 0.863281 1.6875 0.753906 1.5 0.609375 C 1.351562 0.492188 1.234375 0.398438 1.140625 0.328125 C 1.046875 0.265625 0.9375 0.207031 0.8125 0.15625 C 0.695312 0.113281 0.582031 0.09375 0.46875 0.09375 C 0.425781 0.09375 0.394531 0.09375 0.375 0.09375 L 1 -2.78125 C 0.8125 -2.707031 0.664062 -2.59375 0.5625 -2.4375 C 0.457031 -2.28125 0.40625 -2.09375 0.40625 -1.875 C 0.40625 -1.769531 0.414062 -1.695312 0.4375 -1.65625 C 0.457031 -1.613281 0.46875 -1.59375 0.46875 -1.59375 C 0.320312 -1.59375 0.210938 -1.625 0.140625 -1.6875 C 0.0664062 -1.75 0.03125 -1.851562 0.03125 -2 C 0.03125 -2.175781 0.101562 -2.347656 0.25 -2.515625 C 0.394531 -2.679688 0.578125 -2.816406 0.796875 -2.921875 C 1.023438 -3.023438 1.253906 -3.078125 1.484375 -3.078125 C 1.523438 -3.078125 1.582031 -3.070312 1.65625 -3.0625 L 1.015625 -0.078125 C 1.085938 -0.0546875 1.164062 -0.03125 1.25 0 C 1.332031 0.0390625 1.429688 0.09375 1.546875 0.15625 C 1.722656 0.25 1.875 0.320312 2 0.375 C 2.132812 0.425781 2.269531 0.453125 2.40625 0.453125 C 2.53125 0.453125 2.644531 0.429688 2.75 0.390625 C 2.726562 0.585938 2.679688 0.742188 2.609375 0.859375 C 2.535156 0.984375 2.441406 1.046875 2.328125 1.046875 Z M 2.328125 1.046875",
    transform: "translate(6.345 32.782)"
  }))))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    fill: "#00C2CB"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.6875 -2.296875 C 0.601562 -2.296875 0.523438 -2.328125 0.453125 -2.390625 C 0.390625 -2.460938 0.359375 -2.539062 0.359375 -2.625 C 0.359375 -2.71875 0.390625 -2.796875 0.453125 -2.859375 C 0.523438 -2.929688 0.601562 -2.96875 0.6875 -2.96875 C 0.78125 -2.96875 0.859375 -2.929688 0.921875 -2.859375 C 0.992188 -2.796875 1.03125 -2.71875 1.03125 -2.625 C 1.03125 -2.539062 0.992188 -2.460938 0.921875 -2.390625 C 0.859375 -2.328125 0.78125 -2.296875 0.6875 -2.296875 Z M 0.40625 0.03125 C 0.28125 0.03125 0.175781 -0.0078125 0.09375 -0.09375 C 0.0078125 -0.175781 -0.03125 -0.300781 -0.03125 -0.46875 C -0.03125 -0.539062 -0.0195312 -0.632812 0 -0.75 L 0.28125 -2.078125 L 0.875 -2.078125 L 0.578125 -0.671875 C 0.566406 -0.628906 0.5625 -0.582031 0.5625 -0.53125 C 0.5625 -0.476562 0.570312 -0.4375 0.59375 -0.40625 C 0.625 -0.382812 0.671875 -0.375 0.734375 -0.375 C 0.816406 -0.375 0.890625 -0.40625 0.953125 -0.46875 C 1.023438 -0.539062 1.078125 -0.632812 1.109375 -0.75 L 1.28125 -0.75 C 1.175781 -0.445312 1.039062 -0.238281 0.875 -0.125 C 0.71875 -0.0195312 0.5625 0.03125 0.40625 0.03125 Z M 0.40625 0.03125",
    transform: "translate(7.917 32.782)"
  }))))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    fill: "#00C2CB"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.59375 0.03125 C 0.382812 0.03125 0.222656 -0.0195312 0.109375 -0.125 C 0.00390625 -0.238281 -0.046875 -0.410156 -0.046875 -0.640625 C -0.046875 -0.828125 -0.0078125 -1.035156 0.0625 -1.265625 C 0.132812 -1.492188 0.253906 -1.691406 0.421875 -1.859375 C 0.585938 -2.023438 0.800781 -2.109375 1.0625 -2.109375 C 1.226562 -2.109375 1.347656 -2.070312 1.421875 -2 C 1.492188 -1.9375 1.53125 -1.847656 1.53125 -1.734375 C 1.53125 -1.640625 1.507812 -1.566406 1.46875 -1.515625 C 1.425781 -1.460938 1.375 -1.4375 1.3125 -1.4375 C 1.257812 -1.4375 1.207031 -1.453125 1.15625 -1.484375 C 1.1875 -1.566406 1.203125 -1.644531 1.203125 -1.71875 C 1.203125 -1.769531 1.191406 -1.8125 1.171875 -1.84375 C 1.160156 -1.875 1.132812 -1.890625 1.09375 -1.890625 C 1.007812 -1.890625 0.925781 -1.820312 0.84375 -1.6875 C 0.757812 -1.550781 0.691406 -1.382812 0.640625 -1.1875 C 0.585938 -1 0.5625 -0.828125 0.5625 -0.671875 C 0.5625 -0.535156 0.582031 -0.441406 0.625 -0.390625 C 0.675781 -0.347656 0.753906 -0.328125 0.859375 -0.328125 C 1.003906 -0.328125 1.128906 -0.359375 1.234375 -0.421875 C 1.347656 -0.492188 1.46875 -0.601562 1.59375 -0.75 L 1.734375 -0.75 C 1.429688 -0.226562 1.050781 0.03125 0.59375 0.03125 Z M 0.59375 0.03125",
    transform: "translate(9.025 32.782)"
  }))))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    fill: "#00C2CB"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.59375 0.03125 C 0.382812 0.03125 0.222656 -0.0195312 0.109375 -0.125 C 0.00390625 -0.238281 -0.046875 -0.410156 -0.046875 -0.640625 C -0.046875 -0.828125 -0.0078125 -1.035156 0.0625 -1.265625 C 0.132812 -1.492188 0.253906 -1.691406 0.421875 -1.859375 C 0.585938 -2.023438 0.800781 -2.109375 1.0625 -2.109375 C 1.375 -2.109375 1.53125 -1.976562 1.53125 -1.71875 C 1.53125 -1.5625 1.484375 -1.414062 1.390625 -1.28125 C 1.304688 -1.15625 1.1875 -1.050781 1.03125 -0.96875 C 0.882812 -0.894531 0.726562 -0.851562 0.5625 -0.84375 C 0.5625 -0.757812 0.5625 -0.703125 0.5625 -0.671875 C 0.5625 -0.535156 0.582031 -0.441406 0.625 -0.390625 C 0.675781 -0.347656 0.753906 -0.328125 0.859375 -0.328125 C 1.003906 -0.328125 1.128906 -0.359375 1.234375 -0.421875 C 1.347656 -0.492188 1.46875 -0.601562 1.59375 -0.75 L 1.734375 -0.75 C 1.429688 -0.226562 1.050781 0.03125 0.59375 0.03125 Z M 0.609375 -1.046875 C 0.703125 -1.046875 0.796875 -1.078125 0.890625 -1.140625 C 0.984375 -1.210938 1.054688 -1.296875 1.109375 -1.390625 C 1.171875 -1.492188 1.203125 -1.601562 1.203125 -1.71875 C 1.203125 -1.832031 1.164062 -1.890625 1.09375 -1.890625 C 1 -1.890625 0.90625 -1.800781 0.8125 -1.625 C 0.71875 -1.457031 0.648438 -1.265625 0.609375 -1.046875 Z M 0.609375 -1.046875",
    transform: "translate(10.618 32.782)"
  }))))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    fill: "#00C2CB"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.5 0.03125 C 1.332031 0.03125 1.207031 -0.015625 1.125 -0.109375 C 1.050781 -0.203125 1.015625 -0.3125 1.015625 -0.4375 C 1.015625 -0.5 1.019531 -0.566406 1.03125 -0.640625 C 1.039062 -0.710938 1.050781 -0.78125 1.0625 -0.84375 C 1.082031 -0.914062 1.097656 -0.960938 1.109375 -0.984375 C 1.128906 -1.085938 1.148438 -1.1875 1.171875 -1.28125 C 1.191406 -1.375 1.203125 -1.445312 1.203125 -1.5 C 1.203125 -1.644531 1.148438 -1.71875 1.046875 -1.71875 C 0.972656 -1.71875 0.90625 -1.679688 0.84375 -1.609375 C 0.789062 -1.535156 0.75 -1.441406 0.71875 -1.328125 L 0.4375 0 L -0.15625 0 L 0.28125 -2.078125 L 0.875 -2.078125 L 0.828125 -1.859375 C 0.972656 -2.015625 1.140625 -2.09375 1.328125 -2.09375 C 1.460938 -2.09375 1.570312 -2.050781 1.65625 -1.96875 C 1.738281 -1.894531 1.78125 -1.78125 1.78125 -1.625 C 1.78125 -1.539062 1.769531 -1.445312 1.75 -1.34375 C 1.726562 -1.25 1.703125 -1.132812 1.671875 -1 C 1.648438 -0.914062 1.628906 -0.832031 1.609375 -0.75 C 1.585938 -0.664062 1.578125 -0.597656 1.578125 -0.546875 C 1.578125 -0.492188 1.585938 -0.453125 1.609375 -0.421875 C 1.640625 -0.390625 1.6875 -0.375 1.75 -0.375 C 1.832031 -0.375 1.898438 -0.40625 1.953125 -0.46875 C 2.003906 -0.53125 2.050781 -0.625 2.09375 -0.75 L 2.28125 -0.75 C 2.175781 -0.4375 2.054688 -0.226562 1.921875 -0.125 C 1.785156 -0.0195312 1.644531 0.03125 1.5 0.03125 Z M 1.5 0.03125",
    transform: "translate(12.21 32.782)"
  }))))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    fill: "#00C2CB"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.46875 0.03125 C 0.34375 0.03125 0.234375 0.00390625 0.140625 -0.046875 C 0.046875 -0.0976562 -0.0195312 -0.164062 -0.0625 -0.25 C -0.113281 -0.332031 -0.140625 -0.414062 -0.140625 -0.5 C -0.140625 -0.59375 -0.113281 -0.671875 -0.0625 -0.734375 C -0.0195312 -0.804688 0.03125 -0.859375 0.09375 -0.890625 C 0.195312 -1.085938 0.285156 -1.285156 0.359375 -1.484375 C 0.441406 -1.679688 0.519531 -1.894531 0.59375 -2.125 L 1.21875 -2.203125 C 1.226562 -1.847656 1.25 -1.46875 1.28125 -1.0625 C 1.300781 -0.894531 1.3125 -0.769531 1.3125 -0.6875 C 1.3125 -0.625 1.300781 -0.570312 1.28125 -0.53125 C 1.414062 -0.601562 1.519531 -0.675781 1.59375 -0.75 L 1.765625 -0.75 C 1.585938 -0.539062 1.375 -0.363281 1.125 -0.21875 C 1.039062 -0.132812 0.941406 -0.0703125 0.828125 -0.03125 C 0.710938 0.0078125 0.59375 0.03125 0.46875 0.03125 Z M 0.34375 -0.296875 C 0.445312 -0.296875 0.53125 -0.328125 0.59375 -0.390625 C 0.664062 -0.453125 0.703125 -0.550781 0.703125 -0.6875 C 0.703125 -0.769531 0.691406 -0.890625 0.671875 -1.046875 C 0.648438 -1.359375 0.632812 -1.566406 0.625 -1.671875 C 0.5625 -1.453125 0.445312 -1.191406 0.28125 -0.890625 C 0.34375 -0.859375 0.375 -0.8125 0.375 -0.75 C 0.375 -0.695312 0.359375 -0.648438 0.328125 -0.609375 C 0.296875 -0.566406 0.253906 -0.546875 0.203125 -0.546875 C 0.140625 -0.546875 0.101562 -0.5625 0.09375 -0.59375 C 0.09375 -0.488281 0.109375 -0.410156 0.140625 -0.359375 C 0.179688 -0.316406 0.25 -0.296875 0.34375 -0.296875 Z M 0.34375 -0.296875",
    transform: "translate(14.306 32.782)"
  }))))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    fill: "#00C2CB"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.59375 0.03125 C 0.382812 0.03125 0.222656 -0.0195312 0.109375 -0.125 C 0.00390625 -0.238281 -0.046875 -0.410156 -0.046875 -0.640625 C -0.046875 -0.828125 -0.0078125 -1.035156 0.0625 -1.265625 C 0.132812 -1.492188 0.253906 -1.691406 0.421875 -1.859375 C 0.585938 -2.023438 0.800781 -2.109375 1.0625 -2.109375 C 1.375 -2.109375 1.53125 -1.976562 1.53125 -1.71875 C 1.53125 -1.5625 1.484375 -1.414062 1.390625 -1.28125 C 1.304688 -1.15625 1.1875 -1.050781 1.03125 -0.96875 C 0.882812 -0.894531 0.726562 -0.851562 0.5625 -0.84375 C 0.5625 -0.757812 0.5625 -0.703125 0.5625 -0.671875 C 0.5625 -0.535156 0.582031 -0.441406 0.625 -0.390625 C 0.675781 -0.347656 0.753906 -0.328125 0.859375 -0.328125 C 1.003906 -0.328125 1.128906 -0.359375 1.234375 -0.421875 C 1.347656 -0.492188 1.46875 -0.601562 1.59375 -0.75 L 1.734375 -0.75 C 1.429688 -0.226562 1.050781 0.03125 0.59375 0.03125 Z M 0.609375 -1.046875 C 0.703125 -1.046875 0.796875 -1.078125 0.890625 -1.140625 C 0.984375 -1.210938 1.054688 -1.296875 1.109375 -1.390625 C 1.171875 -1.492188 1.203125 -1.601562 1.203125 -1.71875 C 1.203125 -1.832031 1.164062 -1.890625 1.09375 -1.890625 C 1 -1.890625 0.90625 -1.800781 0.8125 -1.625 C 0.71875 -1.457031 0.648438 -1.265625 0.609375 -1.046875 Z M 0.609375 -1.046875",
    transform: "translate(15.89 32.782)"
  }))))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    fill: "#00C2CB"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.40625 0.03125 C 0.28125 0.03125 0.175781 -0.0078125 0.09375 -0.09375 C 0.0078125 -0.175781 -0.03125 -0.300781 -0.03125 -0.46875 C -0.03125 -0.539062 -0.0195312 -0.632812 0 -0.75 L 0.25 -1.90625 L 0.109375 -1.90625 L 0.140625 -2.078125 L 0.28125 -2.078125 L 0.40625 -2.65625 L 1.015625 -2.734375 L 0.875 -2.078125 L 1.125 -2.078125 L 1.09375 -1.90625 L 0.84375 -1.90625 L 0.578125 -0.671875 C 0.566406 -0.628906 0.5625 -0.582031 0.5625 -0.53125 C 0.5625 -0.476562 0.570312 -0.4375 0.59375 -0.40625 C 0.625 -0.382812 0.671875 -0.375 0.734375 -0.375 C 0.816406 -0.375 0.890625 -0.40625 0.953125 -0.46875 C 1.023438 -0.539062 1.078125 -0.632812 1.109375 -0.75 L 1.28125 -0.75 C 1.175781 -0.445312 1.039062 -0.238281 0.875 -0.125 C 0.71875 -0.0195312 0.5625 0.03125 0.40625 0.03125 Z M 0.40625 0.03125",
    transform: "translate(18.384 32.782)"
  }))))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    fill: "#00C2CB"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.609375 0.015625 C 0.398438 0.015625 0.234375 -0.0351562 0.109375 -0.140625 C -0.00390625 -0.242188 -0.0625 -0.410156 -0.0625 -0.640625 C -0.0625 -0.828125 -0.0234375 -1.035156 0.046875 -1.265625 C 0.128906 -1.492188 0.253906 -1.691406 0.421875 -1.859375 C 0.597656 -2.023438 0.816406 -2.109375 1.078125 -2.109375 C 1.429688 -2.109375 1.609375 -1.890625 1.609375 -1.453125 C 1.617188 -1.441406 1.632812 -1.4375 1.65625 -1.4375 C 1.75 -1.4375 1.851562 -1.460938 1.96875 -1.515625 C 2.09375 -1.566406 2.203125 -1.625 2.296875 -1.6875 L 2.328125 -1.578125 C 2.253906 -1.492188 2.148438 -1.421875 2.015625 -1.359375 C 1.890625 -1.296875 1.75 -1.253906 1.59375 -1.234375 C 1.570312 -0.984375 1.515625 -0.765625 1.421875 -0.578125 C 1.335938 -0.390625 1.222656 -0.242188 1.078125 -0.140625 C 0.929688 -0.0351562 0.773438 0.015625 0.609375 0.015625 Z M 0.765625 -0.359375 C 0.835938 -0.359375 0.90625 -0.394531 0.96875 -0.46875 C 1.039062 -0.550781 1.097656 -0.65625 1.140625 -0.78125 C 1.191406 -0.914062 1.226562 -1.0625 1.25 -1.21875 C 1.175781 -1.238281 1.140625 -1.296875 1.140625 -1.390625 C 1.140625 -1.503906 1.179688 -1.582031 1.265625 -1.625 C 1.265625 -1.71875 1.253906 -1.78125 1.234375 -1.8125 C 1.210938 -1.84375 1.171875 -1.859375 1.109375 -1.859375 C 1.023438 -1.859375 0.9375 -1.789062 0.84375 -1.65625 C 0.757812 -1.53125 0.691406 -1.375 0.640625 -1.1875 C 0.585938 -1 0.5625 -0.832031 0.5625 -0.6875 C 0.5625 -0.5625 0.578125 -0.472656 0.609375 -0.421875 C 0.640625 -0.378906 0.691406 -0.359375 0.765625 -0.359375 Z M 0.765625 -0.359375",
    transform: "translate(19.491 32.782)"
  }))))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    fill: "#00C2CB"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.015625 0.078125 C 0.835938 0.078125 0.679688 0.046875 0.546875 -0.015625 C 0.421875 -0.078125 0.320312 -0.160156 0.25 -0.265625 C 0.175781 -0.378906 0.140625 -0.507812 0.140625 -0.65625 C 0.140625 -0.769531 0.164062 -0.878906 0.21875 -0.984375 C 0.269531 -1.085938 0.335938 -1.164062 0.421875 -1.21875 C 0.515625 -1.28125 0.613281 -1.3125 0.71875 -1.3125 C 0.8125 -1.3125 0.890625 -1.285156 0.953125 -1.234375 C 1.023438 -1.179688 1.066406 -1.113281 1.078125 -1.03125 C 0.941406 -1.03125 0.828125 -0.992188 0.734375 -0.921875 C 0.648438 -0.847656 0.609375 -0.742188 0.609375 -0.609375 C 0.609375 -0.492188 0.644531 -0.398438 0.71875 -0.328125 C 0.789062 -0.253906 0.882812 -0.21875 1 -0.21875 C 1.144531 -0.21875 1.265625 -0.265625 1.359375 -0.359375 C 1.460938 -0.460938 1.515625 -0.585938 1.515625 -0.734375 C 1.515625 -0.867188 1.476562 -0.992188 1.40625 -1.109375 C 1.332031 -1.222656 1.222656 -1.363281 1.078125 -1.53125 C 0.929688 -1.695312 0.816406 -1.84375 0.734375 -1.96875 C 0.660156 -2.09375 0.625 -2.226562 0.625 -2.375 C 0.625 -2.519531 0.664062 -2.648438 0.75 -2.765625 C 0.832031 -2.878906 0.941406 -2.96875 1.078125 -3.03125 C 1.222656 -3.101562 1.382812 -3.140625 1.5625 -3.140625 C 1.78125 -3.140625 1.957031 -3.085938 2.09375 -2.984375 C 2.226562 -2.878906 2.296875 -2.738281 2.296875 -2.5625 C 2.296875 -2.4375 2.265625 -2.335938 2.203125 -2.265625 C 2.148438 -2.203125 2.078125 -2.171875 1.984375 -2.171875 C 1.878906 -2.171875 1.796875 -2.210938 1.734375 -2.296875 C 1.785156 -2.335938 1.828125 -2.390625 1.859375 -2.453125 C 1.890625 -2.515625 1.90625 -2.578125 1.90625 -2.640625 C 1.90625 -2.734375 1.875 -2.804688 1.8125 -2.859375 C 1.757812 -2.910156 1.691406 -2.9375 1.609375 -2.9375 C 1.492188 -2.9375 1.398438 -2.894531 1.328125 -2.8125 C 1.253906 -2.738281 1.21875 -2.640625 1.21875 -2.515625 C 1.21875 -2.410156 1.25 -2.304688 1.3125 -2.203125 C 1.382812 -2.109375 1.488281 -1.988281 1.625 -1.84375 C 1.726562 -1.71875 1.8125 -1.613281 1.875 -1.53125 C 1.945312 -1.445312 2.007812 -1.347656 2.0625 -1.234375 C 2.113281 -1.117188 2.140625 -1 2.140625 -0.875 C 2.140625 -0.695312 2.085938 -0.535156 1.984375 -0.390625 C 1.890625 -0.242188 1.753906 -0.128906 1.578125 -0.046875 C 1.410156 0.0351562 1.222656 0.078125 1.015625 0.078125 Z M 1.015625 0.078125",
    transform: "translate(22.213 32.782)"
  }))))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    fill: "#00C2CB"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.59375 0.03125 C 0.382812 0.03125 0.222656 -0.0195312 0.109375 -0.125 C 0.00390625 -0.238281 -0.046875 -0.410156 -0.046875 -0.640625 C -0.046875 -0.828125 -0.0078125 -1.035156 0.0625 -1.265625 C 0.132812 -1.492188 0.253906 -1.691406 0.421875 -1.859375 C 0.585938 -2.023438 0.800781 -2.109375 1.0625 -2.109375 C 1.375 -2.109375 1.53125 -1.976562 1.53125 -1.71875 C 1.53125 -1.5625 1.484375 -1.414062 1.390625 -1.28125 C 1.304688 -1.15625 1.1875 -1.050781 1.03125 -0.96875 C 0.882812 -0.894531 0.726562 -0.851562 0.5625 -0.84375 C 0.5625 -0.757812 0.5625 -0.703125 0.5625 -0.671875 C 0.5625 -0.535156 0.582031 -0.441406 0.625 -0.390625 C 0.675781 -0.347656 0.753906 -0.328125 0.859375 -0.328125 C 1.003906 -0.328125 1.128906 -0.359375 1.234375 -0.421875 C 1.347656 -0.492188 1.46875 -0.601562 1.59375 -0.75 L 1.734375 -0.75 C 1.429688 -0.226562 1.050781 0.03125 0.59375 0.03125 Z M 0.609375 -1.046875 C 0.703125 -1.046875 0.796875 -1.078125 0.890625 -1.140625 C 0.984375 -1.210938 1.054688 -1.296875 1.109375 -1.390625 C 1.171875 -1.492188 1.203125 -1.601562 1.203125 -1.71875 C 1.203125 -1.832031 1.164062 -1.890625 1.09375 -1.890625 C 1 -1.890625 0.90625 -1.800781 0.8125 -1.625 C 0.71875 -1.457031 0.648438 -1.265625 0.609375 -1.046875 Z M 0.609375 -1.046875",
    transform: "translate(24.578 32.782)"
  }))))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    fill: "#00C2CB"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.28125 -2.078125 L 0.875 -2.078125 L 0.828125 -1.828125 C 0.921875 -1.898438 1.003906 -1.957031 1.078125 -2 C 1.160156 -2.050781 1.242188 -2.078125 1.328125 -2.078125 C 1.421875 -2.078125 1.488281 -2.046875 1.53125 -1.984375 C 1.582031 -1.921875 1.609375 -1.847656 1.609375 -1.765625 C 1.609375 -1.679688 1.582031 -1.609375 1.53125 -1.546875 C 1.476562 -1.492188 1.40625 -1.46875 1.3125 -1.46875 C 1.25 -1.46875 1.207031 -1.476562 1.1875 -1.5 C 1.164062 -1.53125 1.148438 -1.578125 1.140625 -1.640625 C 1.140625 -1.671875 1.132812 -1.691406 1.125 -1.703125 C 1.113281 -1.722656 1.097656 -1.734375 1.078125 -1.734375 C 1.015625 -1.734375 0.960938 -1.722656 0.921875 -1.703125 C 0.890625 -1.679688 0.835938 -1.640625 0.765625 -1.578125 L 0.4375 0 L -0.15625 0 Z M 0.28125 -2.078125",
    transform: "translate(26.17 32.782)"
  }))))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    fill: "#00C2CB"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.46875 0.03125 C 0.3125 0.03125 0.1875 -0.0078125 0.09375 -0.09375 C 0.0078125 -0.175781 -0.03125 -0.300781 -0.03125 -0.46875 C -0.03125 -0.53125 -0.0234375 -0.597656 -0.015625 -0.671875 L 0.28125 -2.078125 L 0.875 -2.078125 L 0.578125 -0.671875 C 0.566406 -0.597656 0.5625 -0.546875 0.5625 -0.515625 C 0.5625 -0.421875 0.609375 -0.375 0.703125 -0.375 C 0.828125 -0.375 0.941406 -0.453125 1.046875 -0.609375 C 1.160156 -0.773438 1.25 -0.96875 1.3125 -1.1875 C 1.382812 -1.414062 1.421875 -1.609375 1.421875 -1.765625 C 1.410156 -1.753906 1.390625 -1.742188 1.359375 -1.734375 C 1.335938 -1.722656 1.3125 -1.71875 1.28125 -1.71875 C 1.238281 -1.71875 1.203125 -1.738281 1.171875 -1.78125 C 1.148438 -1.832031 1.140625 -1.882812 1.140625 -1.9375 C 1.140625 -2 1.160156 -2.050781 1.203125 -2.09375 C 1.242188 -2.132812 1.304688 -2.15625 1.390625 -2.15625 C 1.484375 -2.15625 1.550781 -2.117188 1.59375 -2.046875 C 1.632812 -1.984375 1.65625 -1.898438 1.65625 -1.796875 C 1.65625 -1.546875 1.613281 -1.28125 1.53125 -1 C 1.445312 -0.71875 1.316406 -0.472656 1.140625 -0.265625 C 0.960938 -0.0664062 0.738281 0.03125 0.46875 0.03125 Z M 0.46875 0.03125",
    transform: "translate(27.73 32.782)"
  }))))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    fill: "#00C2CB"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.59375 0.03125 C 0.382812 0.03125 0.222656 -0.0195312 0.109375 -0.125 C 0.00390625 -0.238281 -0.046875 -0.410156 -0.046875 -0.640625 C -0.046875 -0.828125 -0.0078125 -1.035156 0.0625 -1.265625 C 0.132812 -1.492188 0.253906 -1.691406 0.421875 -1.859375 C 0.585938 -2.023438 0.800781 -2.109375 1.0625 -2.109375 C 1.375 -2.109375 1.53125 -1.976562 1.53125 -1.71875 C 1.53125 -1.5625 1.484375 -1.414062 1.390625 -1.28125 C 1.304688 -1.15625 1.1875 -1.050781 1.03125 -0.96875 C 0.882812 -0.894531 0.726562 -0.851562 0.5625 -0.84375 C 0.5625 -0.757812 0.5625 -0.703125 0.5625 -0.671875 C 0.5625 -0.535156 0.582031 -0.441406 0.625 -0.390625 C 0.675781 -0.347656 0.753906 -0.328125 0.859375 -0.328125 C 1.003906 -0.328125 1.128906 -0.359375 1.234375 -0.421875 C 1.347656 -0.492188 1.46875 -0.601562 1.59375 -0.75 L 1.734375 -0.75 C 1.429688 -0.226562 1.050781 0.03125 0.59375 0.03125 Z M 0.609375 -1.046875 C 0.703125 -1.046875 0.796875 -1.078125 0.890625 -1.140625 C 0.984375 -1.210938 1.054688 -1.296875 1.109375 -1.390625 C 1.171875 -1.492188 1.203125 -1.601562 1.203125 -1.71875 C 1.203125 -1.832031 1.164062 -1.890625 1.09375 -1.890625 C 1 -1.890625 0.90625 -1.800781 0.8125 -1.625 C 0.71875 -1.457031 0.648438 -1.265625 0.609375 -1.046875 Z M 0.609375 -1.046875",
    transform: "translate(29.448 32.782)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdclogo);
export default __webpack_public_path__ + "static/media/mdclogo.28c1ba356bd6d9301009808551a96224.svg";
export { ForwardRef as ReactComponent };